import { useEffect } from "react"

import { ContactType, ContactTypeValues } from "@aviv-ipp/bff-types"

import { useContactForm } from "./useContactForm"

export const useParamsContactForm = () => {
  const { openContactModal } = useContactForm()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    if (params.has("opencf") || window.location.hash === "#kontakt") {
      const contactTypeParam = params.get("opencf")

      if (
        contactTypeParam &&
        ContactTypeValues.includes(contactTypeParam.toUpperCase() as ContactType)
      ) {
        openContactModal("MESSAGE", contactTypeParam.toUpperCase() as ContactType)
      } else {
        openContactModal("MESSAGE")
      }
    }
  }, [])
}
